<template>
  <div>
    <main>
      <TopBar />
      <!-- <Header /> -->
      <slot></slot>
      <!-- <Footer /> -->
    </main>
  </div>
</template>
